module.exports = __webpack_public_path__ + "static/media/PoppinsMedium500.06582556.ttf";